import { render, staticRenderFns } from "./Actitemlist.vue?vue&type=template&id=63b55ae0&scoped=true"
import script from "./Actitemlist.vue?vue&type=script&lang=js"
export * from "./Actitemlist.vue?vue&type=script&lang=js"
import style0 from "./Actitemlist.vue?vue&type=style&index=0&id=63b55ae0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b55ae0",
  null
  
)

export default component.exports